/** Keeps the exact wire request until its outcome is known. This prevents a lost
 * response followed by edited inputs from becoming a second financial write. */
export class AccountWriteAttempt {
  private request?: Readonly<{ path: string; method: string; body: string }>;
  uncertain = false;

  begin(path: string, method: string, payload: unknown) {
    this.request ??= Object.freeze({ path, method, body: JSON.stringify(payload) });
    return this.request;
  }

  failed(status?: number) {
    this.uncertain = status === undefined || status >= 500;
    if (!this.uncertain) this.request = undefined;
  }

  succeeded() { this.request = undefined; this.uncertain = false; }
}
